import { render } from "./vphonecard.vue?vue&type=template&id=25283317&scoped=true"
import script from "./vphonecard.vue?vue&type=script&lang=js"
export * from "./vphonecard.vue?vue&type=script&lang=js"

import "./vphonecard.vue?vue&type=style&index=0&id=25283317&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25283317"]])

export default __exports__